var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavIconWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0667 14.133L15.4584 8.04137C14.575 5.9747 12.95 5.89137 11.8584 7.85803L10.2834 10.6997C9.48335 12.1414 7.99169 12.2664 6.95835 10.9747L6.77502 10.7414C5.70002 9.39137 4.18335 9.55803 3.40835 11.0997L1.97502 13.9747C0.966686 15.9747 2.42502 18.333 4.65835 18.333H15.2917C17.4584 18.333 18.9167 16.1247 18.0667 14.133Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80835 6.66602C7.18906 6.66602 8.30835 5.54673 8.30835 4.16602C8.30835 2.7853 7.18906 1.66602 5.80835 1.66602C4.42764 1.66602 3.30835 2.7853 3.30835 4.16602C3.30835 5.54673 4.42764 6.66602 5.80835 6.66602Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavIconWhite);
export default __webpack_public_path__ + "static/media/favIcon-white.9295db3739c2d83dbbc4d71376a589c7.svg";
export { ForwardRef as ReactComponent };